<template>
  <div class="row myrow">
    <div class="col-xs-12 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td>№ п/п</td>
            <td>
              Производственный/вспомогательный участок/технологическая линия
            </td>
            <td>
              Даты завершения работ по
              строительству/переоборудованию/модернизации
            </td>
            <td>Почтовый адрес, расположение, цех, участок</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in project.TEGNOLOGICAL_LINES.items"
            :key="index"
          >
            <template v-if="editable">
              <td>{{ index + 1 }}</td>
              <td
                v-bind:class="{
                  'has-error': hasError(index, 'UF_TEGNOLOGICAL_LINE')
                }"
              >
                <textarea
                  class="i-main-style t-co-executor-style t-dop-style"
                  v-model="item.UF_TEGNOLOGICAL_LINE"
                  maxlength="200"
                  @keyup="removeError(index, 'UF_TEGNOLOGICAL_LINE')"
                />
                <span class="frp-input-description"
                  >Доступно для ввода символов:
                  {{ countEntChar(item.UF_TEGNOLOGICAL_LINE, 200) }}
                </span>
                <div class="error-text">
                  {{ errorText(index, "UF_TEGNOLOGICAL_LINE") }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'has-error': hasError(index, 'UF_DATE_COMPLETION')
                }"
              >
                <textarea
                  class="i-main-style t-co-executor-style t-dop-style"
                  v-model="item.UF_DATE_COMPLETION"
                  maxlength="200"
                  @keyup="removeError(index, 'UF_DATE_COMPLETION')"
                />
                <span class="frp-input-description"
                  >Доступно для ввода символов:
                  {{ countEntChar(item.UF_DATE_COMPLETION, 200) }}
                </span>
                <div class="error-text">
                  {{ errorText(index, "UF_DATE_COMPLETION") }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'has-error': hasError(index, 'UF_POSTAL_ADDRESS')
                }"
              >
                <textarea
                  class="i-main-style t-co-executor-style t-dop-style"
                  v-model="item.UF_POSTAL_ADDRESS"
                  maxlength="200"
                  @keyup="removeError(index, 'UF_POSTAL_ADDRESS')"
                />
                <span class="frp-input-description"
                  >Доступно для ввода символов:
                  {{ countEntChar(item.UF_POSTAL_ADDRESS, 200) }}
                </span>
                <div class="error-text">
                  {{ errorText(index, "UF_POSTAL_ADDRESS") }}
                </div>
              </td>
              <td>
                <i
                  class="i-delete centerIcon"
                  title="Удалить запись"
                  @click="deleteItem(index)"
                ></i>
              </td>
            </template>
            <template v-else>
              <td>{{ index + 1 }}</td>
              <td>
                {{ item.UF_TEGNOLOGICAL_LINE }}
              </td>
              <td>{{ item.UF_DATE_COMPLETION }}</td>
              <td>{{ item.UF_POSTAL_ADDRESS }}</td>
              <td v-if="editable">
                <i
                  class="i-delete centerIcon"
                  title="Удалить запись"
                  @click="deleteItem(index)"
                ></i>
              </td>
              <td v-else></td>
            </template>
          </tr>
        </tbody>
      </table>
      <div class="add-row" v-show="editable">
        <a class="link-add-row" v-on:click="addItem">Добавить запись</a>
      </div>

      <button
        type="button"
        @click="saveItemProject()"
        v-show="editable"
        class="btn btn-success"
      >
        Сохранить
      </button>
      <button
        type="button"
        @click="getListTargetProject()"
        v-show="editable"
        class="btn btn-default"
      >
        Отмена
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ProjectsService } from "@/common/api.service";
//import DigitalSolutionList from "@/components/project/form/lists/DigitalSolutionList";

export default {
  name: "technological_line",
  props: ["project", "editable"],
  components: {},
  data() {
    return {
      listErrors: []
    };
  },
  methods: {
    hasError(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          return true;
        }
      }

      return false;
    },
    errorText(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          return this.listErrors[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          Vue.delete(this.listErrors[col], field);
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.project.TEGNOLOGICAL_LINES.items === "undefined") {
        this.project.TEGNOLOGICAL_LINES = {
          items: []
        };
      }
      this.project.TEGNOLOGICAL_LINES.items.push({
        UF_TEGNOLOGICAL_LINE: "",
        UF_DATE_COMPLETION: "",
        UF_POSTAL_ADDRESS: ""
      });

      this.editableRows[
        this.project.TEGNOLOGICAL_LINES.items.length - 1
      ] = true;
    },
    deleteItem(index) {
      this.project.TEGNOLOGICAL_LINES.items.splice(index, 1);
    },
    saveItemProject() {
      this.listErrors = [];
      ProjectsService.saveTegnologicalLinesProject(this.$route.params.id, {
        items: this.project.TEGNOLOGICAL_LINES.items
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });

            if (!this.listErrors[text.DOP_INFO.ROW_NUM]) {
              this.listErrors[text.DOP_INFO.ROW_NUM] = [];
            }
            this.listErrors[text.DOP_INFO.ROW_NUM][text.DOP_INFO.COL[0]] =
              text.TEXT;
          }, this);
          if (data.isSetTansactionBD) {
            this.project.TEGNOLOGICAL_LINES.items = data.items;
          }
          return;
        } else {
          this.$toasted.show(
            "Данные о производственных участках и технологических линиях сохранены",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
          if (data.isSetTansactionBD) {
            this.project.TEGNOLOGICAL_LINES.items = data.items;
          }
          this.editableRows = [];
        }
      }, this);
    },
    getListTargetProject() {
      ProjectsService.getTechnologicLinesProject(this.$route.params.id).then(
        ({ data }) => {
          if (data) {
            this.project.TEGNOLOGICAL_LINES.items = data;
          }
        },
        this
      );
    },
    countEntChar(value, limit) {
      if (value) {
        const length = String(value).length;
        return length > limit ? 0 : limit - length;
      }
      return limit;
    }
  }
};
</script>

<style scoped></style>
